import { z } from 'zod';
import { CreateAddressInputDTOSchema } from "../../../addresses/models/dtos/create-address.dto.js";
import { CreateBankAccountInputDTOSchema } from "../../../bank-accounts/models/dtos/create-bank-account.dto.js";
import { BaseFacilityDTOSchema, } from "./facilities.dto.js";
// Schema for input validation when creating a facility
export const CreateFacilityInputDTOSchema = BaseFacilityDTOSchema.omit({
    id: true,
    slug: true,
    address: true,
    bankAccount: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
}).extend({
    legalName: z.string().min(2).max(128),
    address: CreateAddressInputDTOSchema,
    bankAccount: CreateBankAccountInputDTOSchema.nullable().optional(),
});
// Request and response schemas for the API layer
export const CreateFacilityRequestDTOSchema = z.object({
    body: CreateFacilityInputDTOSchema.omit({
        companyId: true,
    }),
    params: z.object({
        companyId: CreateFacilityInputDTOSchema.shape.companyId,
    }),
});
//# sourceMappingURL=create-facility.dto.js.map